module.exports = __webpack_public_path__ + "df62d8a0b62f45699a9eb3f91a8dc119.png";